/** 供应商账号：userCode 小写后以 hc / hp 开头（大小写不敏感） */
export const isSupplierUserCode = (userCode?: string | null): boolean => {
  if (!userCode) {
    return false;
  }
  const lower = userCode.toLocaleLowerCase();
  return lower.startsWith('hc') || lower.startsWith('hp');
};

/** 供应商账号 API / 缓存 key 统一为小写，其余账号保持原样 */
export const normalizeUserCode = (userCode: string): string =>
  isSupplierUserCode(userCode) ? userCode.toLocaleLowerCase() : userCode;
